export default {
  LOGIN: {
    path: '/',
    name: 'Login',
  },
  HOME: {
    path: '/',
    name: 'Home',
  },
  CAMPAIGN: {
    path: '/campaign',
    name: 'Campaign',
  },
  ADD_CAMPAIGN: {
    path: '/campaign/add',
    name: 'AddCampaign',
  },
  EDIT_CAMPAIGN: {
    path: '/campaign/edit/:id',
    name: 'EditCampaign',
  },
  EDIT_CAMPAIGN_CONTENT: {
    path: '/campaign/content/edit/:type',
    name: 'EditCampaignContent',
  },
  EDIT_CAMPAIGN_PREREGISTER: {
    path: '/campaign/pre-register/:id',
    name: 'PreRegister',
  },
  BRANCH: {
    path: '/branch',
    name: 'Branch',
  },
  ADD_BRANCH: {
    path: '/branch/add',
    name: 'AddBranch',
  },
  EDIT_BRANCH: {
    path: '/branch/edit/:id',
    name: 'EditBranch',
  },
  ADD_BRANCH_TIME: {
    path: '/branch/:bId/time',
    name: 'AddBranchTime',
  },
  EDIT_BRANCH_TIME: {
    path: '/branch/:bId/time/:id',
    name: 'EditBranchTime',
  },
  PRODUCT: {
    path: '/product',
    name: 'Product',
  },
  ADD_PRODUCT: {
    path: '/product/add',
    name: 'AddProduct',
  },
  EDIT_PRODUCT: {
    path: '/product/edit/:id',
    name: 'EditProduct',
  },
  COUPON: {
    path: '/coupon',
    name: 'Coupon',
  },
  ADD_COUPON: {
    path: '/coupon/add',
    name: 'AddCoupon',
  },
  EDIT_COUPON: {
    path: '/coupon/edit/:id/:code',
    name: 'EditCoupon',
  },
  ORDER: {
    path: '/order',
    name: 'Order',
  },
  MAIN_PRODUCT: {
    path: '/main-product',
    name: 'MainProduct',
  },
  ADD_MAIN_PRODUCT: {
    path: '/main-product/add',
    name: 'AddMainProduct',
  },
  EDIT_MAIN_PRODUCT: {
    path: '/main-product/edit/:id',
    name: 'EditMainProduct',
  },
  PAYMENT: {
    path: '/payment',
    name: 'Payment',
  },
  EDIT_PAYMENT: {
    path: '/payment/edit/:id',
    name: 'EditPayment',
  },
  COUPON_PURCHASED: {
    path: '/coupon-purchased',
    name: 'CouponPurchased',
  },
  ADD_COUPON_PURCHASED: {
    path: '/coupon-purchased/add',
    name: 'AddCouponPurchased',
  },
  EDIT_COUPON_PURCHASED: {
    path: '/coupon-purchased/edit/:id/:code',
    name: 'EditCouponPurchased',
  },
  ITEC_LOGS: {
    path: '/itec-logs',
    name: 'ItecLogs',
  },
  PAYMENT_LOGS: {
    path: '/payment-logs',
    name: 'PaymentLogs',
  },

  PRE_REGISTER: {
    path: '/pre-register',
    name: 'PreRegister',
  },

  PRE_REGISTER_CREATE_FORM: {
    path: '/pre-register/create-form',
    name: 'PreRegisterCreateForm',
  },

  STATIC_PAGE: {
    path: '/static-page',
    name: 'StaticPage',
  },
  ADD_STATIC_PAGE: {
    path: '/static-page/add',
    name: 'AddStaticPage',
  },
  EDIT_STATIC_PAGE: {
    path: '/static-page/edit/:id',
    name: 'EditStaticPage',
  },

  PRODUCT_QUOTA_TIME: {
    path: '/product-quota-time',
    name: 'ProductQuotaTime',
  },

  REPORT_PRODUCT_QUOTA_TIME: {
    path: '/report/product-quota-time',
    name: 'ReportProductQuotaTime',
  },

  SMS: {
    path: '/lon',
    name: 'LON',
  },

  ORDER_HISTORY_SAMSUNG: {
    path: '/report/samsung',
    name: 'SamsungOrderReport',
  },
}
